export const NotificationState = Object.freeze({
  New: 0,
  Opened: 1,
  Completed: 2,
  Dismissed: 3
})

export const NotificationType = Object.freeze({
  Default: 0,
  Item: 1,
  Contributor: 2,
  PricingError: 3,
  AzureAlert: 4
})

export const NotificationItemSearchType = Object.freeze({
  Title: 0,
  Contributor: 1,
  SkuOrIsbn: 2
})
